import { jsx as _jsx } from "react/jsx-runtime";
import { ZipInCardStateEnum, ZipInModalEnum } from '@inter-ikea-kompis/component-zip-in';
import { SheetAlignmentEnum, ZipValidationDataSourceEnum } from '@inter-ikea-kompis/enums';
import { KompisZipIn } from '@inter-ikea-kompis/react-components';
import { ZipValidationService } from '@inter-ikea-kompis/services';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { useEffect, useState } from 'react';
const validateZipCode = async (zipCode, settings, dexfApiKey) => {
    const isServiceAvailable = settings.kompis.serviceSettings.zipValidationDataSource !==
        ZipValidationDataSourceEnum.disabled;
    if (isServiceAvailable) {
        const service = new ZipValidationService({ settings, dexfApiKey: dexfApiKey });
        return await service.getZipValidation(zipCode);
    }
    return { valid: false, zipCode };
};
export const HomeDeliverySheet = ({ kompisTranslations, zipCode, onZipCodeChange, visible, closeZipSelector, settings, dexfApiKey }) => {
    const [zipState, setZipState] = useState(ZipInCardStateEnum.default);
    useEffect(() => {
        if (zipState === ZipInCardStateEnum.default && zipCode) {
            setZipState(ZipInCardStateEnum.submitted);
        }
    }, [zipCode, zipState]);
    const validateZip = async (zipCode) => {
        try {
            if (!settings) {
                return null;
            }
            const zipValidation = await validateZipCode(zipCode, settings, dexfApiKey);
            if (zipValidation.valid && zipValidation.content?.formatted) {
                return zipValidation.content.formatted;
            }
            return null;
        }
        catch {
            setZipState(ZipInCardStateEnum.noZipInfo);
        }
    };
    const handleSubmit = (event) => {
        const { zipCode: zipValue } = event.detail;
        setZipState(ZipInCardStateEnum.loading);
        validateZip(zipValue).then(validatedZip => {
            if (validatedZip) {
                onZipCodeChange(validatedZip);
                setZipState(ZipInCardStateEnum.submitted);
                closeZipSelector();
            }
            else if (zipValue) {
                setZipState(ZipInCardStateEnum.invalidInput);
            }
            else {
                onZipCodeChange(null);
                setZipState(ZipInCardStateEnum.default);
            }
        });
    };
    const handleForget = () => {
        onZipCodeChange(null);
        setZipState(ZipInCardStateEnum.default);
        closeZipSelector();
    };
    return (_jsx(KompisZipIn, { theme: SkapaTheme, translations: kompisTranslations, onForget: handleForget, sheetAlignment: SheetAlignmentEnum.left, state: zipState, onSave: handleSubmit, onModalClose: () => {
            setZipState(zipCode ? ZipInCardStateEnum.submitted : ZipInCardStateEnum.default);
            closeZipSelector();
        }, zipCode: zipCode, visibleModal: visible ? ZipInModalEnum.zipIn : null }));
};
//# sourceMappingURL=HomeDeliverySheet.js.map